"use strict";
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var browserWebSocket_1 = require("./browserWebSocket");
exports.BrowserWebSocket = browserWebSocket_1.BrowserWebSocket;
var webSocketClient_1 = require("./webSocketClient");
exports.WebSocketClient = webSocketClient_1.WebSocketClient;
var webSocketServer_1 = require("./webSocketServer");
exports.WebSocketServer = webSocketServer_1.WebSocketServer;
var webSocketTransport_1 = require("./webSocketTransport");
exports.WebSocketTransport = webSocketTransport_1.WebSocketTransport;
//# sourceMappingURL=index-browser.js.map